import { render, staticRenderFns } from "./CurrencyBuyDocumentList.vue?vue&type=template&id=aac1dc28&"
import script from "./CurrencyBuyDocumentList.vue?vue&type=script&lang=js&"
export * from "./CurrencyBuyDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports